import script from "./ProjectInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectInformation.vue?vue&type=script&setup=true&lang=js"

import "./ProjectInformation.vue?vue&type=style&index=0&id=f3a5efe0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3a5efe0"]])

export default __exports__